/**
 * --------------------------------------------------------------------------
 * Basic Modules: MainMenu.js
 * --------------------------------------------------------------------------
 */

//import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'mainMenu';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    delay               : 200,
    fade                : 500,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

// const ClassName = {};

const Selector = {
    TOGGLE              : '.js-main-menu',
    DROPDOWN            : '.dropdown',
    DROPDOWN_MENU       : '.dropdown-menu',
};

// const DataAttr = {};

class MainMenu {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;
        this.scrollInitialized = false;

        this._element = element;
        this._config  = this._getConfig(config);

        this._handleMenuHover();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _handleMenuHover() {

        let _this = this;

        $(this._element).find(Selector.DROPDOWN).hover(function() {
            $(this).find(Selector.DROPDOWN_MENU).stop(true, true).delay(_this._config.delay).fadeIn(_this._config.fade);
        }, function() {
            $(this).find(Selector.DROPDOWN_MENU).stop(true, true).delay(_this._config.delay).fadeOut(_this._config.fade);
        });

    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        MainMenu._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new MainMenu(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = MainMenu._jQueryInterface;
$.fn[NAME].Constructor = MainMenu;


export default MainMenu;
